module.exports = __webpack_public_path__ + "static/media/kingpin.55a342e2.png";